import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  TextField,
  FormControl,
  Select,
  makeStyles,
  Box,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import _ from 'lodash';
import { connect } from 'react-redux';
import Colours from '../../styles/colours';
import DateRangeInput from './DateRangeInput';
import { Status } from '../../common/constants';
import { dateStrToFormat } from '../../common/convert';
import { Trim } from '../../common/util';
import { IsEmpty } from '../../common/checks';
import MText from './MText';
import MButton from '../MButton';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
  halfWidth: {
    width: '50%',
  },
  w200: {
    width: '200px',
  },
  w250: {
    width: '250px',
  },
  bgWhite: {
    backgroundColor: Colours.White,
  },
}));

function FilterPost(props) {
  const classes = useStyles();

  const [isOpenModal, setIsOpenModal]       = useState(false);
  const [fieldStartDate, setFieldStartDate] = useState(null);
  const [fieldEndDate, setFieldEndDate]     = useState(null);
  const [startDate, setStartDate]           = useState(null);
  const [endDate, setEndDate]               = useState(null);
  const [status, setStatus]                 = useState('');

  const onTitleChange = (data) => {
    // to replace double whitespace before & after each word with ''
    const trimmedTitle = Trim(data, false, false);
    props.updateTitleFilter(trimmedTitle);
  };

  const debounceTitle = _.debounce(onTitleChange, 700);

  const onDateRangeChange = (data) => {
    setStartDate(dateStrToFormat(data.startDate));
    setEndDate(dateStrToFormat(data.endDate));
  };

  const onDateRangeModalClose = () => {
    if (!IsEmpty(startDate) && !IsEmpty(endDate)) {
      setFieldStartDate(startDate);
      setFieldEndDate(endDate);
      props.updatePostDateFilter({ startDate, endDate });
    }

    setIsOpenModal(false);
  };

  const resetDateRange = () => {
    setStartDate(null);
    setEndDate(null);
    setFieldStartDate(null);
    setFieldEndDate(null);
    props.updatePostDateFilter();
    setIsOpenModal(false);
  };

  const onStatusChange = (data) => {
    setStatus(data);
    props.updateStatusFilter(data);
  };

  return (
    <div className={props.isMobile ? `d-block` : ` mt-1 d-flex flex-row justify-content-start flex-wrap`}>
      <div className="mr-sm-2 mb-1">
        <MText text="Title" size={11} />
        <TextField
          className={props.isMobile ? `mt-1 ${classes.fullWidth} ${classes.bgWhite}` : `mt-1 ${classes.w250} ${classes.bgWhite}`}
          variant="outlined"
          size="small"
          defaultValue=""
          maxRows={8}
          inputProps={{
            'aria-label': 'naked',
            style:        {
              fontSize: 12,
            },
          }}
          onChange={(e) => debounceTitle(e.target.value)}
        />
      </div>

      <div className={`${props.isMobile ? `mt-3` : `mr-sm-2`} mb-1`}>
        <MText text="Post Date" size={11} />
        <Box className="d-flex" style={{ alignItems: 'baseline' }}>
          <TextField
            className={props.isMobile ? `${classes.fullWidth} ${classes.bgWhite} mt-1` : `${classes.w200} ${classes.bgWhite} mt-1`}
            variant="outlined"
            size="small"
            value={`${IsEmpty(fieldStartDate) ? '' : fieldStartDate} ${(!IsEmpty(fieldStartDate) || !IsEmpty(fieldEndDate)) ? ' to ' : ''} ${IsEmpty(fieldEndDate) ? '' : fieldEndDate}`}
            onClick={() => setIsOpenModal(true)}
            inputProps={{
              readOnly: true,
              style:    {
                fontSize: 12,
              },
            }}
          />
        </Box>

        <Dialog
          open={isOpenModal}
          onClose={onDateRangeModalClose}
        >
          <DialogContent>
            <Box style={{ textAlign: 'center', paddingBottom: '12px' }}>
              <Typography variant="body2" color="inherit" style={{ color: Colours.Gray }}>
                Select Start and End Dates
              </Typography>
              <DateRangeInput startDate={startDate} endDate={endDate} onDateRangeChange={onDateRangeChange} />
              <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                <MButton
                  text="Clear Dates"
                  onClick={resetDateRange}
                />
                <MButton
                  text="Done"
                  onClick={onDateRangeModalClose}
                />
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </div>

      <div className={`${props.isMobile ? `mt-3` : `mr-sm-2`} mb-1`}>
        <MText text="Status" size={11} />
        <FormControl
          size="small"
          className={props.isMobile ? `${classes.fullWidth} mt-1` : `${classes.w200} mt-1`}
          variant="outlined"
        >
          <Select
            native
            value={status}
            onChange={(e) => onStatusChange(e.target.value)}
            className={classes.bgWhite}
            style={{ height: '2.23rem' }}
            inputProps={{
              style: {
                fontSize: 12,
                height:   '2.2rem',
              },
            }}
          >
            <option aria-label="None" value="" />
            <option value={Status.Draft}>Draft</option>
            <option value={Status.Live}>Live</option>
            <option value={Status.Pending}>Pending</option>
            <option value={Status.Paused}>Paused</option>
          </Select>
        </FormControl>
      </div>
    </div>
  );
}

FilterPost.propTypes = {
  isMobile:             PropTypes.bool,
  updateStatusFilter:   PropTypes.func.isRequired,
  updateTitleFilter:    PropTypes.func.isRequired,
  updatePostDateFilter: PropTypes.func.isRequired,
  windowSize:           PropTypes.string.isRequired,
};

FilterPost.defaultProps = {
  isMobile: false,
};

const mapStateToProps = (state) => ({
  windowSize: state.layout.windowSize,
});

export default connect(mapStateToProps, null)(FilterPost);
